/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { ThemeProvider as HatchThemeProvider } from '@usehatchapp/material';
import { getNavHelper } from 'internal-nav-helper';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import React, { useEffect } from 'react';
import { useConnect } from 'redux-bundler-hook';
import { ThemeProvider } from 'styled-components';
import { Userpilot } from 'userpilot';

import Notifications from './components/molecules/Notifications';
import Router from './components/views/Router';
import { useResize } from './hooks/useResize';

function getLauchDarklyContext({ orgId }) {
  // For now, we will keep the orgId as key for the User context to keep the flags working
  // the same way as before the concept of contexts was created by Launch Darkly (v3)
  // Also, this is adding the new "organization" context, so new flags can use it
  const organizationContext = {
    id: orgId,
    key: `organization-${orgId}`,
    kind: 'organization',
  };
  const userContext = {
    key: `organization-${orgId}`, // keep orgId as key for the user context
    kind: 'user',
  };
  const multiContext = {
    kind: 'multi',
    organization: organizationContext,
    user: userContext,
  };
  return multiContext;
}

const App = () => {
  const {
    doUpdateWindowSize,
    doUpdateUrl,
    theme,
    currentOrganizationId,
    fullUser,
    routeInfo,
  } = useConnect(
    'selectTheme',
    'doUpdateWindowSize',
    'doUpdateUrl',
    'selectCurrentOrganizationId',
    'selectFullUser',
    'selectRouteInfo',
  );
  useResize(doUpdateWindowSize);

  // call UserPiolt initialize onmount
  useEffect(() => {
    const userPilotToken = process.env.USERPILOT_TOKEN || 'NX-3e1b2b13';
    Userpilot.initialize(userPilotToken);
  }, []);

  useEffect(() => {
    if (fullUser?.id) {
      Userpilot.identify(fullUser.id, {
        email: fullUser.email,
        isAdmin: fullUser.isAdmin,
        name: fullUser.fullName,
        role: 'manager',
      });
    }
  }, [fullUser]);

  useEffect(() => {
    if (fullUser?.id) {
      Userpilot.reload();
    }
    // dont trigger when fullUser is updated, only when route changes
    // but need to check if the user is logged in
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routeInfo]);

  const ldClient = useLDClient();
  useEffect(() => {
    if (currentOrganizationId) {
      ldClient.identify(
        getLauchDarklyContext({ orgId: currentOrganizationId }),
      );
    }
  }, [ldClient, currentOrganizationId]);

  // application is wrapped in getNavHelper to handle internal vs external anchor links
  return (
    <div
      data-test-id="776b9e91-5540-408e-b4c4-c050db0ea53a"
      onClick={getNavHelper(doUpdateUrl)}
    >
      <ThemeProvider theme={theme}>
        <HatchThemeProvider>
          <Router />
          <Notifications />
        </HatchThemeProvider>
      </ThemeProvider>
    </div>
  );
};

export default App;
